import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class CategoriesAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.adicionar = this.adicionar.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  adicionar(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/categoria', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/categoria/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar categoria</h3>
      <Link to="/categorias" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>Nome*:</label>
              <input type="text" name="name" className="form-control" placeholder="Categoria" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button input={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar categoria</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default CategoriesAdd;



// WEBPACK FOOTER //
// ./src/Components/Categories/CategoriesAdd.js